/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, createContext, forwardRef } from 'react';
import { type ContextValue, Provider, Select as SelectCore, type SelectProps as SelectCoreProps, useContextProps } from 'react-aria-components';
import { $ } from '../../tokens.stylex';
import { HintContext } from '../hint/hint.component';
import { LabelContext, type LabelProps } from '../label/label.component';
import { ListBoxContext } from '../list-box/list-box.component';
import { SelectInputStyleContext } from '../select-input/select-input.component';

interface SelectStyleProps {
  /** The size variant of the text field. (Default: 48) */
  size?: keyof typeof sizeVariants;
  style?: stylex.StyleXStyles;
}

type SelectProps = Omit<SelectCoreProps, 'style' | 'className'> & SelectStyleProps;

const SelectStyleContext = createContext<ContextValue<SelectStyleProps, HTMLDivElement>>({});

const Select = forwardRef((props: SelectProps, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, SelectStyleContext);

  const { style, children, size = 48, ...coreProps } = props;

  return (
    <SelectCore ref={ref} {...stylex.props(styles.base, sizeVariants[size], style)} {...coreProps}>
      {(renderProps) => (
        <Provider values={[
          [LabelContext, { size: LABEL_SIZES[size] }],
          [SelectInputStyleContext, { size }],
          [HintContext, { style: hintSizeVariants[size] }],
          [ListBoxContext, { style: listBoxStyles.base }]
        ]}>
          {typeof children === 'function' ? children?.(renderProps) : children}
        </Provider>
      )}
    </SelectCore>
  );
});

const LABEL_SIZES: Record<keyof typeof sizeVariants, LabelProps['size']> = {
  48: 16,
  32: 13,
};

const styles = stylex.create({
  base: {
    display: 'flex',
    flexDirection: 'column'
  },
});

const listBoxStyles = stylex.create({
  base: {
    padding: 4,
    borderRadius: 10,
    backgroundColor: $.surfaceBGPrimary,
    boxShadow: $.shadowCenter070Loud,
  }
});

const sizeVariants = stylex.create({
  48: { gap: 6 },
  32: { gap: 4 }
});

const hintSizeVariants = stylex.create({
  48: { marginTop: -2 },
  32: {}
});

export { Select, SelectStyleContext, type SelectProps, type SelectStyleProps };

